import { InvoiceRepository } from '../../domain/repositories/InvoiceRepository';

export class DeleteInvoice {
    constructor(private invoiceRepository: InvoiceRepository) {}

    async execute(invoiceKey: string): Promise<void> {
        await this.invoiceRepository.delete(invoiceKey);
    }
}
